// Centralized network configuration for the application

// Helper function to get API URL - handles both development and production
export const getApiUrl = () => {
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const serverPort = process.env.REACT_APP_SERVER_PORT;
  
  if (!serverUrl) {
    throw new Error('REACT_APP_SERVER_URL environment variable is required');
  }

  let url = serverUrl;

  // If it's a production HTTPS URL or already includes a port, don't append port
  if (serverUrl.startsWith('https://') || serverUrl.includes(':')) {
    url = serverUrl;
  } else {
    // For development (HTTP without port), append the port
    if (serverPort) {
      url = `${serverUrl}:${serverPort}`;
    }
  }
  
  // Remove trailing slash to prevent double slashes when constructing endpoints
  return url.replace(/\/$/, '');
};

// API Server URL configuration
export const API_URL = getApiUrl();

// Client URL configuration  
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;

// Development check
export const isDevelopment = process.env.NODE_ENV === 'development';

export default {
  API_URL,
  CLIENT_URL,
  isDevelopment,
  getApiUrl
}; 